/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get, isDragging, isVisualizerDrag) => set(produce(get(), (draft) => {
  if (!draft.design) {
    draft.design = {};
  }

  draft.design.dragEvent = {
    isDragging,
    isVisualizerDrag,
  };

}), false, { type: 'HANDLE_DRAG_EVENT' });